// rishab code
import React, { useState, useEffect, useCallback } from "react";
import BreadCrumb from "../../../components/breadCrumb/BreadCrumb";
import SaveNewHeader from "../../../components/customPageHeader/SaveNewHeader";
import "./AddCustomer.scss";
import CustomTextBox from "../../../components/customTextBox/CustomTextBox";
import CustomDropdown from "../../../components/customDropDown/CustomDropdown";
import { custStatusDataSource2, typeOptions, yesnoDataSource } from "../data";
import { SelectBox, TextBox, Button } from "devextreme-react";
import CustomOtpPopup from "../../../components/customPopup/CustomOtpPopup";
import { ToastDisplayer } from "../../../components/toastDisplay/ToastDisplayer";
import { LoadPanel } from "devextreme-react";
import {
  getCountryState,
  getCustomerCode,
  requestAddressFromPin,
  saveCustomer,
} from "../../../api/companyCustomerApi";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../contexts/auth";
import { validateEmail } from "../../../components/login-form/LoginForm";
import { generateOtpWithAction } from "../../../api/forgotPwdApi";
import { getCategoryData } from "../../../api/settingsApi";
import AddNewTicketHeader from "../../../components/customPageHeader/SaveNewHeader";
import AddNewSubHeader from "../../../components/customPageHeader/SaveNewHeader";

export default function AddCustomer() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [isOtpPopupVisible, setisOtpPopupVisible] = useState(false);
  const [countryOptions, setCountryOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [chkOtpVerify, setChkOtpVerify] = useState("N");
  const [categories, setCategories] = useState([]);
  const [pinCodeRect, setPinCodeRect] = useState(false);

  const [formData, setFormData] = useState({
    custcode: "",
    custname: "",
    custemail: "",
    custpassword: "",
    cntctname: "",
    custphno: "",
    custstatus: "active",
    custtype: "",
    custgstno: "",
    custregaddr: "",
    custcity: "",
    custpincode: "",
    custstate: "",
    custcountry: "",
    custisdeleted: 0,
    companytransid: null,
    custlogo: "",
    passwordreq: "changed",
    isotpverified: "N",
    show_working_hrs: "",
  });

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const response = await getCategoryData();
        const categoryData = response.data.map((category) => ({
          value: category.ticketcategoryname,
          text: category.ticketcategoryname,
        }));
        setCategories(categoryData);
      } catch (error) {
        ToastDisplayer("error", "Failed to fetch categories");
      }
    };
    fetchCategories();
  }, []);

  // Form Validation
  const validateForm = () => {
    const newErrors = {};
    if (!formData.custname) newErrors.custname = "Customer name is required.";

    if (!formData.custemail) {
      newErrors.custemail = "Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.custemail)) {
      newErrors.custemail = "Invalid email format.";
    }

    // if (!formData.custpassword) {
    //   newErrors.custpassword = "Password is required.";
    // } else
    // if (
    //   formData.custpassword?.trim() &&
    //   formData.custpassword.length > 15
    // )
    //   newErrors.custpassword = "Password must not be greater 15 characters";

    if (formData.custgstno.length !== 15) {
      newErrors.custgstno =
        "The GST number must have 15 alphanumeric characters!";
    }
    if (!formData.show_working_hrs)
      newErrors.show_working_hrs =
        "Please select if Total Work Hours should be shown for this customer.";

    if (!formData.custregaddr) newErrors.custregaddr = "Address is required.";

    if (!formData.custcity) newErrors.custcity = "City is required.";

    if (!formData.custpincode) {
      newErrors.custpincode = "Pin code is required.";
    } else if (!/^\d{6}$/.test(formData.custpincode)) {
      newErrors.custpincode = "Pin code must be 6 digits.";
    } else if (!pinCodeRect) {
      newErrors.custpincode = "Please enter valid pincode!";
    }

    if (!formData.custcountry) newErrors.custcountry = "Country is required.";
    if (!formData.custstatus) newErrors.custstatus = "Status Type is required.";
    if (!formData.custstate) newErrors.custstate = "State is required.";
    // if (!formData.custtype) newErrors.custtype = "Type is required.";
    setErrors(newErrors);
    Object.values(newErrors).forEach((error) => {
      ToastDisplayer("error", error);
    });
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await getCountryState();
        const countriesData = response.data.map((country) => ({
          value: country.name,
          text: country.name,
          states: country.states.map((state) => ({
            value: state.name,
            text: state.name,
          })),
        }));

        setCountryOptions(countriesData);
      } catch (error) {
        ToastDisplayer("error", error.response?.data?.msg); // edited for the data error message
      }
    };
    fetchCountries();
  }, []);

  useEffect(() => {
    const selectedCountry = countryOptions.find(
      (country) => country.value === formData.custcountry,
    );
    if (selectedCountry) {
      setStateOptions(selectedCountry.states);
    } else {
      setStateOptions([]);
    }
  }, [formData.custcountry, countryOptions]);

  ////// maitri code
  const handleInputChange = (field) => {
    return (e) => {
      const newValue = e.value;
      setFormData((prev) => {
        if (field === "custemail" && prev.custemail !== newValue) {
          setChkOtpVerify("N");
          return {
            ...prev,
            [field]: newValue,
            isotpverified: "N",
          };
        }
        return {
          ...prev,
          [field]: newValue,
        };
      });

      setErrors((prevErrors) => ({
        ...prevErrors,
        [field]: undefined,
      }));
    };
  };

  const handleSelectBoxChange = (field) => {
    return (e) => {
      const newValue = e.value;
      setFormData((prev) => {
        return {
          ...prev,
          [field]: newValue,
        };
      });
      setErrors((prevErrors) => ({
        ...prevErrors,
        [field]: undefined,
      }));
    };
  };

  //Fetching the customer code
  const fetchCustomerCode = async () => {
    try {
      setLoading(true);
      const response = await getCustomerCode();
      if (response.data && response.data.customer_code) {
        setFormData((prevState) => ({
          ...prevState,
          custcode: response.data.customer_code,
        }));
      } else {
        ToastDisplayer("error", "Error in Generating customer code");
      }
    } catch (error) {
      ToastDisplayer("error", "Error in Generating customer code");
    } finally {
      setLoading(false);
    }
  };

  // useEffect to fetch the Customer Code everytime the page gets reload
  useEffect(() => {
    fetchCustomerCode();
  }, []);

  const toggleOtpPopup = () => {
    setisOtpPopupVisible(!isOtpPopupVisible);
  };

  const handleCustOtpPopup = async () => {
    try {
      const trimmedEmail = formData?.custemail.trim();
      if (!trimmedEmail || !validateEmail(trimmedEmail)) {
        return ToastDisplayer(
          "error",
          !trimmedEmail
            ? "Email address cannot be empty."
            : "Please enter a valid email address.",
        );
      }

      setLoading(true);

      const result = await generateOtpWithAction(formData?.custemail, "C");
      if (result?.data) {
        ToastDisplayer("success", result.data.message);
        setisOtpPopupVisible(!isOtpPopupVisible);
      }
    } catch (error) {
      ToastDisplayer("error", error.response.data.error);
    } finally {
      setLoading(false);
    }
  };

  // Handles the save details and send the data in database and give proper errors
  const handleSaveDetails = async () => {
    if (!validateForm()) return;
    try {
      setLoading(true);
      const modifiedFormData = {
        ...formData,
        custstatus: formData.custstatus,
        companytransid: user?.companytransid,
        isotpverified: chkOtpVerify,
      };

      // uncomment this
      const response = await saveCustomer(modifiedFormData);
      if (response) {
        ToastDisplayer("success", "Save Details Successfully");
        navigate("/client");
      } else {
        ToastDisplayer("error", "Unsuccessful");
      }
    } catch (error) {
      ToastDisplayer(
        "error",
        error.response?.data?.errors?.non_field_errors || error.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  const handleGetAddress = async (pinCode) => {
    setLoading(true);
    if (pinCode.length === 6) {
      const getAddress = await requestAddressFromPin(pinCode);
      if (getAddress.length === 0 || getAddress[0].Status === "Error") {
        setLoading(false);
        setPinCodeRect(false);
        return;
      } else {
        setPinCodeRect(true);
        const add = getAddress[0].PostOffice[0];
        setFormData((prev) => {
          return {
            ...prev,
            custcountry: add.Country,
            custstate: add.State,
            custcity: add.District,
          };
        });
      }
    }
    setLoading(false);
  };

  return (
    <>
      {loading && <LoadPanel visible={true} />}
      {/* <AddNewSubHeader
        titleName="Client"
        handleCancel={handleCancel}
        handleSaveDetails={handleSaveDetails}
        iconClass={"ri-user-add-line"}
        cancelText={"Cancel"}
        saveText={"Save Details"}
      /> */}
      <div className="addCustPage">
        <div className="headerComponent">
          <div className="headerContainer1">
            <div className="title">
              <span class="icon-size">
                <i class="ri-user-add-line"></i>
              </span>
              {/* <p>Add Client</p> */}
              <BreadCrumb />
            </div>
          </div>
          <div className="headerContainer2">
            <Button
              text="Cancel"
              // icon="add"
              stylingMode="outlined"
              type="default"
              width={140}
              onClick={handleCancel}
            />

            <Button
              className="saveBtn"
              text="Save Details"
              // icon="add"
              // stylingMode="outlined"
              type="default"
              width={140}
              onClick={handleSaveDetails}
            />
          </div>
        </div>
        <div
          className="customerMain middlePart"
          style={{ height: "calc(100vh - 208px)" }}
        >
          <div className="mainAddCustSection">
            <CustomTextBox
              label="Client Code"
              placeholder="What's the code?"
              value={formData.custcode}
              readOnly
              type="text"
            />
            <CustomTextBox
              label="Client Name"
              placeholder="What's the name?"
              value={formData.custname}
              onChange={handleInputChange("custname")}
              type="text"
            />
            <div className="MyTextBox">
              <label className="TextBoxLabel">
                Email Address <span className="requiredClass">*</span>
              </label>
              <div className="TextBoxWrapper">
                <TextBox
                  value={formData.custemail}
                  onValueChanged={handleInputChange("custemail")}
                  width={"100%"}
                  stylingMode="outlined"
                  className="TextBoxMain"
                  placeholder="What's email address?"
                  mode="text"
                />
                {/* <span className="email-arrow-icon" onClick={handleCustOtpPopup}>
                  <i className="ri-arrow-right-line"></i>
                </span> */}
              </div>
            </div>
            {/* <CustomTextBox
              label="Password"
              placeholder="Enter Password"
              value={formData.custpassword}
              onChange={handleInputChange("custpassword")}
              type="password"
            /> */}
            <CustomDropdown
              label={"Status"}
              myDataSource={custStatusDataSource2}
              placeholder={"Select Status"}
              value={formData.custstatus}
              setSelectedValue={handleInputChange("custstatus")}
            />
          </div>
          <div className="mainAddCustSection">
            {/* <CustomDropdown
              label={"Type"}
              placeholder={"Select Type"}
              myDataSource={categories}
              value={formData.custtype}
              setSelectedValue={handleInputChange("custtype")}
            /> */}

            <CustomTextBox
              label="Contact Person Name"
              placeholder="Contact Person Name"
              value={formData.cntctname}
              onChange={handleInputChange("cntctname")}
              type="text"
            />
            <CustomTextBox
              label="Contact Number"
              placeholder="Contact Number"
              value={formData.custphno}
              onChange={handleInputChange("custphno")}
              type="text"
            />
            <CustomDropdown
              // label={"Show Total Work Hours for this customer?"}
              label={"Show total work hours?"}
              myDataSource={yesnoDataSource}
              placeholder={"Select Yes/No"}
              // setSelectedValue={setStatus}
              value={formData.show_working_hrs}
              setSelectedValue={handleInputChange("show_working_hrs")}
            />
          </div>
          <div className="mainAddCustSection">
            <CustomTextBox
              label="GST Number"
              placeholder="GST Number"
              value={formData.custgstno}
              onChange={handleInputChange("custgstno")}
              type="text"
            />
            <CustomTextBox
              label="Registered Address"
              placeholder="Company Address"
              value={formData.custregaddr}
              onChange={handleInputChange("custregaddr")}
              type="text"
            />
            <div className="MyTextBox">
              <label className="TextBoxLabel">
                Pin Code <span className="requiredClass">*</span>
              </label>
              <div className="TextBoxWrapper">
                <TextBox
                  stylingMode="outlined"
                  className="TextBoxMain"
                  value={formData?.custpincode}
                  onValueChange={handleGetAddress}
                  onValueChanged={handleInputChange("custpincode")}
                  placeholder="Enter Pin Code"
                />
              </div>
            </div>
            <CustomTextBox
              label="City"
              placeholder="Enter City"
              value={formData.custcity}
              onChange={handleInputChange("custcity")}
              type="text"
            />
            {/* <CustomTextBox
              label="Pin Code"
              placeholder="Enter Pin Code"
              value={formData.custpincode}
              onChange={handleInputChange("custpincode")}
              type="text"
            /> */}

            <CustomTextBox
              label="State"
              placeholder="Enter State"
              value={formData.custstate}
              onChange={handleInputChange("custstate")}
              type="text"
            />
            <CustomTextBox
              label="Country"
              placeholder="Enter Country"
              value={formData.custcountry}
              onChange={handleInputChange("custcountry")}
              type="text"
            />
          </div>
        </div>
      </div>

      <CustomOtpPopup
        visible={isOtpPopupVisible}
        onClose={toggleOtpPopup}
        emailOtp={formData?.custemail}
        setLoading={setLoading}
        setChkOtpVerify={setChkOtpVerify}
      />
    </>
  );
}
